import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function setCarousel() {
  const productsCarousel = document.querySelectorAll('[data-products-carousel]');

  productsCarousel.forEach((section) => {
    const container = section.closest('.carousel');
    const carousel = section.querySelector('.swiper');
    const pagination = section.querySelector('.swiper-pagination');
    const next = container.querySelector('.swiper-button-next');
    const prev = container.querySelector('.swiper-button-prev');

    if (carousel) {
      const swiper = new Swiper(carousel, {
        modules: [Navigation, Pagination],
        loop: true,
        slidesPerView: 1.25,
        spaceBetween: 8,
        watchOverflow: true,
        speed: 1000,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 8,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
          },
          1440: {
            slidesPerView: 4.125,
            spaceBetween: 8,
            navigation: {
              nextEl: next,
              prevEl: prev,
            },
          },
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });
    }
  });
}
